import { Stack } from '@atlaskit/primitives';
import { H5 } from '@atlassian/mpac-primitives';
import * as React from 'react';
import { CurrentSupportAvailability } from './CurrentSupportAvailability';
import { ContactCard } from './styles';
import { SupportContactDetails } from './SupportContactDetails';
import { SupportRequest } from './SupportRequest';
export const SupportContact = props => {
  const {
    supportDetails,
    supportDetails: {
      availability
    },
    onSupportLinkClick
  } = props;
  return /*#__PURE__*/React.createElement(ContactCard, null, /*#__PURE__*/React.createElement(Stack, {
    space: "space.300"
  }, /*#__PURE__*/React.createElement(H5, {
    as: "h3"
  }, "Contact"), /*#__PURE__*/React.createElement(Stack, {
    space: "space.200"
  }, /*#__PURE__*/React.createElement(CurrentSupportAvailability, {
    availability: availability
  }), /*#__PURE__*/React.createElement(SupportContactDetails, {
    supportDetails: supportDetails
  }), /*#__PURE__*/React.createElement(SupportRequest, {
    supportDetails: supportDetails,
    onSupportLinkClick: onSupportLinkClick
  }))));
};